import { type Environment } from 'react-relay';
import { getUserHasConfirmedOrders } from 'dibs-cookie-jar';
import SV from 'server-vars';
import { getIsBotOnClient } from '../helpers/botHelpers.ts';
import { setUserHasConfirmedOrdersCookieMutation } from '../mutations/setUserHasConfirmedOrdersCookieMutation.ts';

export function setUserHasConfirmedOrdersCookie({
    userId,
    environment,
}: {
    userId?: string | null;
    environment: Environment;
}): void {
    const cookieDomain = SV.get('cookieDomain');

    if (
        typeof document === 'undefined' ||
        !userId ||
        !cookieDomain ||
        getIsBotOnClient() ||
        !!getUserHasConfirmedOrders(document.cookie)
    ) {
        return;
    }

    setUserHasConfirmedOrdersCookieMutation(environment, { cookieDomain });
}
